import { createFileRoute } from "@tanstack/react-router";
import { LegalList, LegalPage, LegalSection } from "@/components/LegalPage";

export const Route = createFileRoute("/aviso-legal")({
  head: () => ({
    meta: [
      { title: "Aviso Legal — Projeto 101" },
      {
        name: "description",
        content:
          "Disclaimer do Projeto 101: o conteúdo é educacional e os resultados dependem da execução do usuário. Não há promessa de ganhos financeiros.",
      },
      { property: "og:title", content: "Aviso Legal — Projeto 101" },
      { property: "og:description", content: "Conteúdo educacional. Resultados dependem da execução do usuário." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: AvisoLegalPage,
});

function AvisoLegalPage() {
  return (
    <LegalPage
      title="Aviso Legal (Disclaimer)"
      updatedAt="22 de julho de 2026"
      intro="Este aviso complementa nossos Termos de Uso e esclarece o caráter educacional do produto 101 Negócios Reais."
    >
      <LegalSection n={1} title="Natureza do conteúdo">
        <p>
          Todo o conteúdo disponibilizado pelo Projeto 101, incluindo a Plataforma{" "}
          <em>101 Negócios Reais</em>, bônus, ferramentas, planilhas e área de membros, tem
          finalidade estritamente <strong>educacional e informativa</strong>.
        </p>
        <p>
          O conteúdo não constitui consultoria empresarial, contábil, jurídica, tributária ou
          financeira individualizada.
        </p>
      </LegalSection>

      <LegalSection n={2} title="Ausência de promessa de resultados">
        <p>
          O Projeto 101 <strong>não garante</strong> faturamento, lucro, retorno sobre
          investimento, número de clientes ou qualquer resultado financeiro específico.
        </p>
        <p>Os resultados obtidos por cada usuário dependem, entre outros fatores, de:</p>
        <LegalList
          items={[
            "dedicação e tempo investido;",
            "experiência prévia;",
            "capital disponível;",
            "condições de mercado e localização;",
            "execução prática do que foi estudado.",
          ]}
        />
        <p>
          Qualquer exemplo, simulação, projeção ou estudo de caso apresentado tem função ilustrativa
          e <strong>não representa promessa de rendimento</strong>.
        </p>
      </LegalSection>

      <LegalSection n={3} title="Responsabilidade do usuário">
        <p>
          O usuário é o único responsável pelas decisões que tomar a partir do conteúdo, incluindo:
        </p>
        <LegalList
          items={[
            "escolha do modelo de negócio;",
            "aporte de capital;",
            "contratações e parcerias;",
            "cumprimento de obrigações fiscais, trabalhistas e regulatórias aplicáveis à sua atividade.",
          ]}
        />
        <p>
          Recomendamos buscar orientação profissional especializada (contador, advogado, consultor)
          antes de iniciar qualquer atividade empresarial.
        </p>
      </LegalSection>

      <LegalSection n={4} title="Limitação de responsabilidade">
        <p>
          O Projeto 101 não se responsabiliza por prejuízos, perdas ou danos, diretos ou indiretos,
          decorrentes do uso ou da impossibilidade de uso do material, ou de decisões tomadas com
          base nele.
        </p>
      </LegalSection>

      <LegalSection n={5} title="Marcas e terceiros">
        <p>
          Eventuais menções a marcas, empresas, plataformas ou serviços de terceiros têm finalidade
          exclusivamente ilustrativa e não implicam qualquer vínculo, endosso ou patrocínio, salvo
          quando expressamente indicado.
        </p>
      </LegalSection>

      <LegalSection n={6} title="Contato">
        <p>
          Projeto 101 —{" "}
          <a href="mailto:suporte@101negocios.com.br" className="underline text-[#1E7A5C]">
            suporte@101negocios.com.br
          </a>
        </p>
      </LegalSection>
    </LegalPage>
  );
}
